interface SuggestionsSectionProps {
  userName?: string;
  brandStyle?: string;
}

export default function SuggestionsSection({ userName, brandStyle }: SuggestionsSectionProps) {
  const suggestions = [
    {
      icon: 'ri-search-line',
      title: 'Nghiên Cứu Thị Trường',
      description: 'Tìm hiểu đối thủ cạnh tranh và xu hướng trong lĩnh vực của bạn để tạo BrandName độc đáo và khác biệt',
      color: 'teal'
    },
    {
      icon: 'ri-pencil-ruler-2-line',
      title: 'Thiết Kế Logo Chuyên Nghiệp',
      description: 'Logo là bộ mặt của thương hiệu. Đầu tư vào thiết kế logo đẹp, dễ nhớ và phản ánh đúng giá trị cốt lõi',
      color: 'amber'
    },
    {
      icon: 'ri-palette-line',
      title: 'Xây Dựng Bộ Nhận Diện Thương Hiệu',
      description: 'Tạo bộ màu sắc, font chữ và phong cách thiết kế nhất quán trên mọi kênh truyền thông',
      color: 'rose'
    },
    {
      icon: 'ri-global-line',
      title: 'Hiện Diện Trên Mạng Xã Hội',
      description: 'Xây dựng và duy trì sự hiện diện chuyên nghiệp trên các nền tảng mạng xã hội phù hợp với đối tượng mục tiêu',
      color: 'teal'
    },
    {
      icon: 'ri-article-line',
      title: 'Tạo Nội Dung Giá Trị',
      description: 'Chia sẻ kiến thức, kinh nghiệm và quan điểm của bạn để xây dựng uy tín và thu hút cộng đồng',
      color: 'amber'
    },
    {
      icon: 'ri-team-line',
      title: 'Kết Nối Và Networking',
      description: 'Tham gia các sự kiện, cộng đồng chuyên môn để mở rộng mạng lưới và tăng độ nhận diện thương hiệu',
      color: 'rose'
    }
  ];

  const colorClasses = {
    teal: {
      bg: 'bg-teal-100',
      text: 'text-teal-600',
      border: 'border-teal-200'
    },
    amber: {
      bg: 'bg-amber-100',
      text: 'text-amber-600',
      border: 'border-amber-200'
    },
    rose: {
      bg: 'bg-rose-100',
      text: 'text-rose-600',
      border: 'border-rose-200'
    }
  };

  return (
    <section id="suggestions-section" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
            Gợi Ý Xây Dựng Thương Hiệu Cho <span className="text-teal-600">{userName || 'Bạn'}</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Dựa trên kết quả trắc nghiệm, đây là những gợi ý cụ thể để bạn xây dựng thương hiệu cá nhân ấn tượng
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {suggestions.map((item, index) => {
            const colors = colorClasses[item.color as keyof typeof colorClasses];
            return (
              <div
                key={index}
                className="bg-white rounded-2xl p-8 border-2 border-gray-100 hover:border-gray-200 transition-all duration-300 hover:shadow-xl"
              >
                <div className={`w-14 h-14 flex items-center justify-center ${colors.bg} rounded-xl mb-6`}>
                  <i className={`${item.icon} text-3xl ${colors.text}`}></i>
                </div>
                <h3 className="text-2xl font-bold mb-4 text-gray-900">
                  {item.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>

        <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-3xl p-12 text-white">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl md:text-4xl font-bold mb-6">
                Bắt Đầu Hành Trình Xây Dựng Thương Hiệu Của Bạn
              </h3>
              <p className="text-xl text-white/90 mb-8 leading-relaxed">
                Đừng chần chừ! Mỗi ngày trôi qua là một cơ hội để xây dựng và phát triển BrandName cá nhân của bạn. 
                Hãy bắt đầu ngay hôm nay với những bước đầu tiên.
              </p>
              <ul className="space-y-4">
                <li className="flex items-center gap-3">
                  <i className="ri-checkbox-circle-fill text-2xl text-teal-400"></i>
                  <span className="text-lg">Xác định mục tiêu và giá trị cốt lõi</span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-checkbox-circle-fill text-2xl text-teal-400"></i>
                  <span className="text-lg">Tạo BrandName phù hợp với phong cách</span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-checkbox-circle-fill text-2xl text-teal-400"></i>
                  <span className="text-lg">Xây dựng sự hiện diện trực tuyến</span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-checkbox-circle-fill text-2xl text-teal-400"></i>
                  <span className="text-lg">Duy trì và phát triển liên tục</span>
                </li>
              </ul>
            </div>
            <div>
              <img
                src="https://public.readdy.ai/ai/img_res/c157f6d6d0c9970e3f782672d1f6f27b.jpg"
                alt="Success"
                className="w-full h-96 object-cover rounded-2xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}